export default "__VITE_ASSET__BFmrC3JV__"